// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入css全局样式
import './assets/css/global.css'
// 引入百度地图
// import BaiduMap from 'vue-baidu-map'
// 引入axios
import axios from "axios";
// 引入QS,它的作用是能把json格式的直接转成data所需的格式
import qs from 'qs'
// 引入vue行政区划组件
import Region from 'v-region'
import less from 'less'
// 列表自动滚动的插件
import scroll from 'vue-seamless-scroll'
// 引入重新的message对话框
import { message } from './utils/message.js';
// 全局配置
import '../config/config.js'







Vue.config.productionTip = false
// 使用elemnetui
Vue.use(ElementUI);
// axios.defaults.baseURL = "http://183.11.232.241:8064/api/v1";
// 使用vue行政区划组件
Vue.use(Region);
Vue.use(less);
// 列表自动滚动的插件
Vue.use(scroll)
//全局注册axios，使用方法为:this.$axios
Vue.prototype.$axios = axios;

//挂载自定义的message
Vue.prototype.$message = message;



// 注册一个自定义指令 -- 移动
Vue.directive('dialog-move', function (el, bingding) {
  // 获取需要移动的 dialog 盒子部分
  let moveBox = el.firstElementChild
  // 获取盒子的 header 部分，该部分用做按下移动的功能区域
  let moveElement = el.firstElementChild.firstElementChild
  // 鼠标按下事件
  function mouseDown(e) {
    // 鼠标样式变化
    el.style.cursor = 'move'
    // 记录鼠标位置减去盒子距离浏览器之后剩余的距离
    let X = e.clientX - moveBox.offsetLeft
    let Y = e.clientY - moveBox.offsetTop
    function mouseMove(e) {
      // 取消自带的margin，避免对移动的影响
      moveBox.style.margin = 'inherit'
      // 拖动
      moveBox.style.top = e.clientY - Y + 'px'
      moveBox.style.left = e.clientX - X + 'px'
    }
    // 鼠标移动
    document.addEventListener('mousemove', mouseMove)

    // 鼠标抬起
    document.addEventListener('mouseup', () => {
      el.style.cursor = 'auto'
      // 取消监听鼠标移动
      document.removeEventListener('mousemove', mouseMove)
    })
  }
  // 创建鼠标按下监听事件
  moveElement.addEventListener('mousedown', mouseDown)
})


// 项目打包用到eletron时用到
// Vue.prototype.$api = process.env.NODE_ENV == 'development' ? "/api" : "http://192.168.0.117:8088/centerserver";
Vue.prototype.$api = process.env.NODE_ENV == 'development' ? "/api" : "/api";
// Vue.prototype.$bpi = process.env.NODE_ENV == 'development' ? "ws://192.168.0.97:5052" : "/bpi";
// Vue.prototype.$cpi = process.env.NODE_ENV == 'development' ? "ws://192.168.0.97:5054" : "/cpi";
Vue.prototype.qs = qs           //全局注册qs，使用方法为:this.qs

// 使用百度地图 （需要添加到百度地图API申请的AK）
// Vue.use( BaiduMap, { ak : 'HgptT0SIWKiekXqrZpI9oiTGrosH3oBA' } )

// axios请求拦截
axios.interceptors.request.use(config => {
  //  添加登录请求头
  // console.log(config.url);
  if (config.url == "/api/login") {
    config.headers.Token = "";
    return config;
  }

  //为请求头对象,添加token验证的Authorization字段
  // let token= window.sessionStorage.getItem("token");

  // let a = token.replace('"','');
  // config.headers.Token = a.replace('"','')
  config.headers.Token = window.sessionStorage.getItem("token");
  // console.log(config.headers.Token);
  return config;

}
);


// 返回拦截
axios.interceptors.response.use(response => {

// console.log(response);
  if (response.status == 200) {
    if (response.data.status == 1) {
      message({
        type: 'error',
        showClose: true,
        message: '您的登录信息失效，请重新登录'
      })
      return router.push({ name: 'Login' });
    }
  }


  return response;
  // return  Promise.resolve(response);

}, error => {
  //console.log(error)
  //console.log(error.response)
  //方式一通过返回的error.response
  //很奇怪这里的error.response并没有值，所以我换了另一种方式实现
  // if (error && error.response) {
  //   switch (error.response.status) {
  //     case 404:
  //       router.push({name:'error404'});
  //       break;
  //     case 500:
  //       router.push({ name:'error500'});
  //       break;
  //     default: error.message = `出错了(${error.response.status})!`;
  //   }
  // }
  //方式二
  const errMsg = error.toString()
  const code = errMsg.substr(errMsg.indexOf('code') + 5)
  switch (code) {
    case '404':
      ElementUI.MessageBox({
        // showClose: true,
        title: '错误警告',
        message: '您的访问的页面不存在'
      });

      router.push({ name: '404' });
      break;
    case '405':
      router.push({ name: '404' });
      break;
    case '403':

      ElementUI.Notification({
        title: '警告',
        message: '对不起，请没有相关权限',
        type: 'warning'
      });


      // this.$message.error("对不起，您没有权限");
      break;
    case '500': case '501': case '502': case '503': case '504': case '505': case 'sError: Network Error':
      // let messageBoxFlag = 0 // 默认 MessageBox 未打开
      // if (messageBoxFlag === 0) {
      //   ElementUI.MessageBox({
      //     // showClose: true,
      //     title: '错误警告',
      //     message: '您的服务器可能出错，请检查服务器状态'
      //   })
      //     .then(() => {
      //       messageBoxFlag = 0  // 修改标记          
      //       window.location = window.location.origin
      //     }).catch(() => {
      //       messageBoxFlag = 0  // 修改标记        
      //     })
      // }
      ElementUI.MessageBox({
        // showClose: true,
        title: '错误警告',
        message: '您的服务器可能出错，请检查服务器状态'
      });;
      break;
    default: error.message = `出错了(${error.response.status})!`;
  }
  return Promise.reject(error);
});



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js